import React from "react";
import { LetterOfAuthorization, Header, Subheader, InstructionList,InstructionSubList, ContributionSubList, OwnerAuthority, VanguardRepresentative, SignGurantee, FormInput, AuthorizedOffice, Mail, Email, Fax, Guildelines, Image, Print, CharityACDetails, Address, AuthorizationText, LetterWrapper, FontBoldText } from "./styles";
import logo from '../../../../../../../../assets/icons/vcep-logo.png';
import printIcon from "../../../../../../../../assets/icons/print.svg";
import PrintComponents from "react-print-components";
import { StyleLessButton } from "../../../../../../../../CommonComponents/commonStyles";
import { IconPadding,DataExportPrint } from "../../../../styles";
import { removeHeaderFooter } from "../../../../utils";
let assetOutMF = [];

export class ViewContribution extends React.Component {

    componentDidMount = () => {
        removeHeaderFooter();     
    }

    componentWillUnmount = () => {
        localStorage["assetOutMF"] = "";
    }

    renderPrintData = () => {
        return (
            <LetterOfAuthorization>
            <Image justifyContent = "flex-start" marginBottom="10px">
                <img src={logo} alt="vanguard"></img>
            </Image>
            <Header>Letter of authorization</Header>
            <Subheader>Contribution of mutual fund shares held outside The Vanguard Group, Inc. (Vanguard) or Vanguard
                Brokerage Services (VBS)
            </Subheader>
            <InstructionList>
                <li>
                    Vanguard Charitable account information
                    <div>Account number: { assetOutMF[0].logAcNum }</div>
                    <div>Account name: { assetOutMF[0].logAcName }</div>
                </li>
                <li>
                    Funding instructions
                    <InstructionSubList type="A">
                        <li>
                            Verify pre-populated information and complete any additional information. Print out your
                            completed <AuthorizationText>Letter of authorization</AuthorizationText> and have it signed by all registered owners of the assets being
                            donated. A separate <AuthorizationText>Letter of authorization</AuthorizationText> must be completed for each firm where assets are held,
                            and for different accounts or registrations at the same firm.
                        </li>
                        <li>
                            Provide a copy of a current account statement (dated within 90 days) from the firm holding these
                            shares.
                        </li>
                        <li>
                            Call Vanguard Charitable at 888-383-4483 for transfer instructions before submitting the <AuthorizationText>Letter of authorization</AuthorizationText> and current account statement. The transfer process generally takes four to six weeks
                            to complete.
                        </li>
                    </InstructionSubList>
                </li>
                <li>
                    Transfer-of-ownership instructions
                    <div><FontBoldText>To the transfer agent or broker:</FontBoldText>&nbsp; Please accept this letter as the authorization to irrevocably transfer
                        ownership of the assets specified below to Vanguard Charitable.
                    </div>
                    <div className="mt-10">
                        <div><FontBoldText>Receiving firm information</FontBoldText></div>
                        <div>Receiving firm clearing number: 0062</div>
                        <div>Vanguard Charitable brokerage account number: 76580331</div>
                        <div>Taxpayer ID number: 23-2888152</div>
                    </div>
                    <div className="mt-10"><FontBoldText>Delivering firm information (please complete the blank fields below)</FontBoldText></div>
                    <CharityACDetails marginLeft="0px">
                        <div>Current account registration owner names: <input type="text"/></div>
                        <div>Current firm account number: {assetOutMF[0].accountNumber}</div>
                        <div>Current firm name: {assetOutMF[0].firm}</div>
                    </CharityACDetails>
                    <Address>
                        <div>Current firm street address:<input type="text"/></div>
                        <div>City:<input type="text"/></div>
                        <div>State:<input type="text"/></div>
                        <div>Zip code:<input type="text"/></div>
                    </Address>
                    <table className="center" border="1">
                        <thead>
                            <tr>
                                <th>Number of shares</th>
                                <th>Fund company/Fund name</th>
                                <th>CUSIP or ticker symbol</th>
                                <th>Fund number</th>
                            </tr>
                        </thead>
                        <tbody>
                        {assetOutMF.map((fund) => (
                                    <tr>
                                <td>{fund.shares ? fund.shares : (fund.allShares ? 'All Shares' : fund.shares)}</td>
                                <td>{fund.fundName}</td>
                                <td>{fund.ticker}</td>
                                <td>{fund.fundNumber}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </li>
                <li>
                    Signatures: This section must be signed by all registered owners/trustees/officers of the assets to be donated.
                    <div>I/We hereby irrevocably relinquish all rights, title and interest to the assets specified in Section 3 of this
                        document. I/We hereby acknowledge that I/we have read and understand the terms of the transfer of
                        assets I/we have requested and further acknowledge that the terms of this transfer are binding regardless
                        of any other agreement I/we have with Vanguard Charitable.
                    </div>
                    <div className="mt-10">
                        <FontBoldText>Signature(s)</FontBoldText> Do not sign until you are in the presence of the person guaranteeing your signature.
                    </div>
                    <OwnerAuthority>
                        <div>Owner A</div>
                        <div>Owner's name: {(assetOutMF[0].type === "Joint" || assetOutMF[0].type === "Individual") ? (assetOutMF[0].name): assetOutMF[0].donorName}</div>
                        <div>
                            <div>
                                <label>Signature:</label>
                                <input type="text"></input>
                            </div>
                            <div>
                                <label>Date(mm-dd-yyyy):</label>
                                <input type="text"></input>
                            </div>
                        </div>
                    </OwnerAuthority>
                    { assetOutMF[0].type !== "Individual" ?
                    <OwnerAuthority>
                        <div>Owner B</div>
                        <div>Owner's name: { assetOutMF[0].type !== "Joint" ? assetOutMF[0].donorName : (assetOutMF[0].firstName + ' ' +  assetOutMF[0].lastName)}</div>
                        <div>
                            <div>
                                <label>Signature:</label>
                                <input type="text"></input>
                            </div>
                            <div>
                                <label>Date(mm-dd-yyyy):</label>
                                <input type="text"></input>
                            </div>
                        </div>
                    </OwnerAuthority>
                    : '' }
                    &nbsp;
                    <div>
                        <i>This form requires a Medallion signature guarantee, which can be obtained from a bank or broker - not
                            a notary. Please ensure with your bank, broker, or other financial institution that the signature
                            guarantee(s) provided will cover the amount of the contribution.</i>
                    </div>
                    <SignGurantee>
                        <FontBoldText>Medallion signature guarantee - REQUIRED</FontBoldText>
                        <div>A notary public cannot provide a signature guarantee.</div>
                        <FormInput>
                            <label>Signature of authorized officer:</label>
                            <input type="text"></input>
                        </FormInput>
                        <FormInput>
                            <label>Name of institution:</label>
                            <input type="text"></input>
                        </FormInput>
                        <FormInput>
                            <label>Title:</label>
                            <input type="text"></input>
                        </FormInput>
                        <FormInput>
                            <label>Date:</label>
                            <input type="text"></input>
                        </FormInput>
                        <AuthorizedOffice>
                            <div>
                                Authorized officer to place stamp here.
                            </div>
                            <div>
                                This applies to all signatures in Section 4.
                            </div> 
                        </AuthorizedOffice>
                    </SignGurantee>
                </li>
                <li>Return information
                    <div>
                        Return this completed form by mail to: <FontBoldText>Vanguard Charitable, P.O. Box 9509, Warwick, RI 02889-
                        9509</FontBoldText>
                    </div>
                </li>
            </InstructionList>
            <Guildelines>
                If applicable, Vanguard Charitable will send a tax substantiation letter once the contribution is processed.
                For more information, view our <a href={assetOutMF[0].envURL + "/company-policies/policies-and-guidelines"} target="_blank">
                <span>Policies and guidelines</span></a> booklet.
            </Guildelines>
        </LetterOfAuthorization>       
        ) 
    }

    render() {
        assetOutMF = [];
        assetOutMF = JSON.parse(localStorage["assetOutMF"]);
        return (
                     <LetterWrapper> 
                     <PrintComponents
                        className="i_print"
                        trigger={
                          <Print>
                          <StyleLessButton>
                            <IconPadding className="ml2">
                              <img src={printIcon} alt="print"/>
                              <DataExportPrint>PRINT</DataExportPrint>
                            </IconPadding>
                          </StyleLessButton>
                          </Print>
                        } >
                            {this.renderPrintData()}
                        </PrintComponents>
                     {this.renderPrintData()}
                     </LetterWrapper>
            );
                
    }
}

export default ViewContribution;